'use client';
import {
	BotTokenExpiredModalContent,
	ChannelAccessDeniedModalContent,
	ConnectionErrorModalContent,
	MissingBotTokenModalContent,
	ReLoginModalContent,
	RateLimitModalContent
} from '@/components/fileConnectionErrorModals';
import { telegramErrorMessagesThatNeedReLogin } from '@/lib/utils';
import { useGlobalModal } from '@/store/global-modal';
import { useGlobalStore } from '@/store/global-store';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';


export function useErrorHandler() {
	const { openModal, closeModal } = useGlobalModal();
	const user = useGlobalStore((s) => s.user)
	const router = useRouter();

	function handleError(
		err: unknown,
		options?: {
			onReconnect?: () => Promise<void> | void;
		}
	) {

		if (!user) {
			return "User not found";
		}
		const authType = user.authType;
		const message = err instanceof Error ? err.message : String(err);
		const needsReLogin = telegramErrorMessagesThatNeedReLogin.some((code) =>
			message.includes(code)
		);

		if (needsReLogin && authType === 'user') {
			closeModal(true)
			openModal({
				forceDialog: true,
				content: (
					<ReLoginModalContent
						closeModal={closeModal}
						onReconnect={options?.onReconnect}
					/>
				)
			});
			return "You need to login with this telegram account again. we can't do anything telegram is the one forcing us to do this. "
		}

		if (
			message.includes('CHANNEL_INVALID') ||
			message.includes('CHANNEL_PRIVATE') ||
			message.includes('CHAT_WRITE_FORBIDDEN') ||
			message.includes('CHAT_ADMIN_REQUIRED')
		) {
			closeModal(true)
			openModal({
				forceDialog: true,
				content: (
					<ChannelAccessDeniedModalContent
						authType={authType}
						closeModal={closeModal}
						onReconnect={() => router.push('/connect-telegram')}
					/>
				)
			});
			return authType === 'bot'
				? "We couldn't access your Telegram channel. Did you remove the bot from the channel or revoke its admin permissions?"
				: "We couldn't access your Telegram channel. Did you delete the channel or leave it?"
		}

		if (message.includes('MSGID_DECREASE_RETRY') || message.includes('SERVER_ERROR')) {
			closeModal(true)
			openModal({
				forceDialog: true,
				content: <ConnectionErrorModalContent message={message} />
			});
			return "Connection error. Please try again."
		}

		if (message.includes('ACCESS_TOKEN_EXPIRED')) {
			closeModal(true)
			openModal({
				forceDialog: true,
				content: <BotTokenExpiredModalContent />
			});
			return "Bot Token expired. Please add new bot token."
		}

		if (message.includes('MISSING_BOT_TOKEN')) {
			closeModal(true)
			openModal({
				forceDialog: true,
				content: <MissingBotTokenModalContent />
			});
			return "Missing bot token. Please add bot token."
		}

		if (message.includes('A wait of')) {
			const waitTimeMatch = message.match(/(\d+)\sseconds/);
			if (waitTimeMatch) {
				const waitTime = parseInt(waitTimeMatch[1]);

				closeModal(true);
				openModal({
					forceDialog: true,
					content: <RateLimitModalContent waitTimeInSeconds={waitTime} />
				});
				return `Rate limit exceeded. Please wait ${waitTime} seconds.`;
			}
		}

		console.error("error", err)
		toast.error("Something went wrong. Please try again later.");
	}

	return { handleError };
}


